function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import PropTypes from "prop-types";
import React, { useCallback, useEffect } from 'react';
import { css } from '@emotion/react';
import debounce from 'lodash/debounce';
import { EuiCode, EuiColorPicker, EuiFlexGroup, EuiFlexItem, EuiText, EuiFieldNumber, EuiFieldText, isValidHex, useColorPickerState, useEuiTheme, EuiToolTip, EuiColorPickerSwatch } from '../../../../../src'; // @ts-ignore NOT TS yet

import { humanizeType } from '../../../services/playground/knobs';
import { getDescription } from '../../../services/props/get_description';
export var LANGUAGES = ['javascript', 'html'];

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1qafyux-ThemeValue",
  styles: "padding:0!important;label:ThemeValue;"
} : {
  name: "1qafyux-ThemeValue",
  styles: "padding:0!important;label:ThemeValue;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var ThemeValue = ({
  property,
  name,
  value,
  example,
  groupProps,
  buttonStyle,
  onUpdate,
  type,
  numberProps,
  stringProps,
  colorProps,
  forceUpdateType
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  const [color, setColor, errors] = useColorPickerState(isValidHex(String(value)) ? String(value) : '');
  useEffect(() => {
    if (typeof value === 'string') setColor(value, {
      hex: value,
      isValid: true
    }); // Safe to omit setState function
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]); // eslint-disable-next-line react-hooks/exhaustive-deps

  const debouncedOnUpdate = useCallback(debounce((hex, isValid) => {
    if (isValid) {
      onUpdate && onUpdate(hex);
    }
  }, 100), [onUpdate]);

  const handleColorChange = (text, {
    hex,
    isValid
  }) => {
    setColor(text, {
      hex,
      isValid
    });
    debouncedOnUpdate(hex, isValid);
  };

  let exampleRender;

  if (example !== null && (property === 'colors' || name.toLowerCase().includes('color'))) {
    exampleRender = <EuiFlexItem grow={false}>
        <EuiColorPickerSwatch color={color} disabled />
      </EuiFlexItem>;
  } else if (example || buttonStyle) {
    exampleRender = <EuiFlexItem grow={false}>
        <span css={buttonStyle}>{example}</span>
      </EuiFlexItem>;
  }

  let typeRender;

  if (type?.custom?.origin?.type) {
    typeRender = <span css={/*#__PURE__*/css("font-weight:", euiTheme.font.weight.light, ";color:", euiTheme.colors.subdued, ";;label:typeRender;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))}>
        : {humanizeType(type.custom.origin.type)}
      </span>;
  }

  let descriptionRender;

  if (type?.description) {
    descriptionRender = <>{getDescription(type)}</>;
  }

  const valueRender = () => {
    if (!onUpdate) {
      return <EuiText textAlign="right" size="s" color="subdued">
          <code>{value}</code>
        </EuiText>;
    }

    let updateType = forceUpdateType;

    if (!updateType && (property === 'colors' || name.toLowerCase().includes('color'))) {
      updateType = 'color';
    } else if (!updateType && typeof value === 'number') {
      updateType = 'number';
    } else if (!updateType && property !== 'colors' && !name.toLowerCase().includes('color') && typeof value === 'string') {
      updateType = 'string';
    }

    if (updateType === 'color') {
      return <EuiFlexItem grow={false}>
          <EuiColorPicker swatches={[]} onChange={handleColorChange} color={color} isInvalid={!!errors} compressed {...colorProps} />
        </EuiFlexItem>;
    } else if (updateType === 'number') {
      return <EuiFieldNumber compressed aria-label={`Update ${name} value`} value={Number(value)} onChange={e => onUpdate(Number(e.target.value))} style={{
        width: 64
      }} {...numberProps} />;
    } else if (updateType === 'string') {
      return <EuiFieldText compressed aria-label={`Update ${name} value`} value={String(value)} onChange={e => onUpdate(e.target.value)} style={{
        width: 120
      }} {...stringProps} />;
    }
  };

  name = property ? `${property}.${name}` : name;
  return <EuiFlexGroup responsive={false} alignItems="flexStart" {...groupProps}>
      {exampleRender}
      <EuiFlexItem grow={true}>
        <EuiText size="s">
          <EuiToolTip content={descriptionRender}>
            <EuiCode css={_ref} language="ts" transparentBackground>
              {name}
              {typeRender}
            </EuiCode>
          </EuiToolTip>
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>{valueRender()}</EuiFlexItem>
    </EuiFlexGroup>;
};
ThemeValue.propTypes = {
  property: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.node,
  example: PropTypes.node,
  groupProps: PropTypes.any,
  buttonStyle: PropTypes.any,
  onUpdate: PropTypes.func,
  type: PropTypes.any,
  numberProps: PropTypes.any,
  stringProps: PropTypes.any,
  colorProps: PropTypes.any,
  forceUpdateType: PropTypes.oneOf(["string", "number", "color"])
};

try {
  ThemeValue.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/customizing/_values.tsx',
    description: '',
    displayName: 'ThemeValue',
    methods: [],
    props: {
      property: {
        defaultValue: null,
        description: '',
        name: 'property',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      name: {
        defaultValue: null,
        description: '',
        name: 'name',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      example: {
        defaultValue: null,
        description: '',
        name: 'example',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      groupProps: {
        defaultValue: null,
        description: '',
        name: 'groupProps',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'EuiFlexGroupProps'
        }
      },
      buttonStyle: {
        defaultValue: null,
        description: '',
        name: 'buttonStyle',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'SerializedStyles'
        }
      },
      onUpdate: {
        defaultValue: null,
        description: '',
        name: 'onUpdate',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(color: string | number) => void'
        }
      },
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'any'
        }
      },
      numberProps: {
        defaultValue: null,
        description: '',
        name: 'numberProps',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'EuiFieldNumberProps'
        }
      },
      stringProps: {
        defaultValue: null,
        description: '',
        name: 'stringProps',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'InputHTMLAttributes<HTMLInputElement> & CommonProps & { icon?: IconType | IconShape; isInvalid?: boolean; ... 7 more ...; compressed?: boolean; }'
        }
      },
      colorProps: {
        defaultValue: null,
        description: '',
        name: 'colorProps',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'Partial<EuiColorPickerProps>'
        }
      },
      forceUpdateType: {
        defaultValue: null,
        description: '',
        name: 'forceUpdateType',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/customizing/_values.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"string" | "number" | "color"',
          value: [{
            value: '"string"'
          }, {
            value: '"number"'
          }, {
            value: '"color"'
          }]
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}